import { Trans } from "@lingui/react/macro";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { z } from "zod";

import BackButton from "@/components/back-button";
import LocationsSection from "@/components/locations-section";

import locationsImg from "@/assets/images/auth-image.jpeg";

export const Route = createFileRoute("/_minimal-layout/_auth-layout")({
  component: RouteComponent,
  validateSearch: z.object({
    redirect: z.string().optional().catch(undefined),
  }),
});
const CLIENT_ID = import.meta.env.VITE_GCP_CLIENT_ID as string;
function RouteComponent() {
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <div className="container pt-5 pb-20">
        <div className="mb-5 w-full">
          <BackButton backRef="/">
            <Trans>Back to Home</Trans>
          </BackButton>
        </div>
        <div className="sm:gap-auto flex flex-col justify-between gap-8 sm:flex-row">
          <div className="flex w-full flex-col justify-center sm:min-h-full sm:w-[47%]">
            <Outlet />
          </div>
          <div className="flex h-full w-full items-center justify-center sm:w-[47%]">
            <LocationsSection imgSrc={locationsImg} />
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
}
